<!-- 组件描述：柱状图&折线图&堆叠图 -->
<template>
  <div v-if="sliderScoreDownload">
    <div ref="chart" style=" height: 234px;"></div>
  </div>
  <div v-else class="yxtbiz-as-report__bar flex">
    <div class="yxtbiz-as-report__bar--yaxis color-gray-6 flex flex-vertical flex-between">
      <template v-for="item in getValueLabelData().reverse()">
        <yxt-tooltip :key="item"
                     effect="light"
                     :content="item"
                     open-filter
                     placement="top">
          <div class="ellipsis">{{ item }}</div>
        </yxt-tooltip>
      </template>
    </div>
    <div ref="chartWrap" class="yxtbiz-as-report__bar--wrap flex-1 w0">
      <yxt-scrollbar :fit-height="true">
        <div ref="chart"></div>
        <div ref="chartX" class="flex standard-size-12 color-gray-7">
          <!-- {{ getCategoryLabelData() }} -->
          <template v-for="item in getCategoryLabelData()">
            <yxt-tooltip :key="item"
                         effect="light"
                         :content="item"
                         open-filter
                         placement="top">
              <div class="flex-1 text-center ellipsis-2 ph4">{{ item }}</div>
            </yxt-tooltip>
          </template>
        </div>
      </yxt-scrollbar>
    </div>
  </div>
</template>

<script>
import chart from './chart';

export default {
  name: 'BarChart',
  mixins: [chart],
  data() {
    return {};
  },
  created() {
  },
  mounted() {
    if (!this.sliderScoreDownload) this.initSize();
    this.drawChart(this.$refs.chart, this.chartType);
  },
  methods: {
    initSize() {
      const wrapWidth = this.$refs.chartWrap.clientWidth;
      const dataLength = this.labelList.length;
      const chartWidth = Math.max(48 * dataLength, wrapWidth);
      this.$refs.chart.style.width = chartWidth + 'px';
      this.$refs.chart.style.height = '234px';
      this.$refs.chartX.style.width = chartWidth + 'px';
    }

  }
};
</script>
